import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TFilterId } from '../../../../../../../../types/types';
import { MY_WORK_FILTER_BOARD_ID } from '../../../../../../aside_panel/filterPanelBoard/constants';
import {
    savedFilterSelector
} from '../../../../../../aside_panel/filterPanelBoard/store/selectors/savedFilterSelector';
import {
    savedFilterActionsSet
} from '../../../../../../aside_panel/filterPanelBoard/store/savedFilters/actions/savedFilterActionsSet';
import { metaSet } from '../../../../../../aside_panel/filterPanelBoard/store/filter/actions/metaSet';
import { patchFilter } from '../../../../../../aside_panel/filterPanelBoard/effects/patchFilter';
import {
    savedFilterSet
} from '../../../../../../aside_panel/filterPanelBoard/store/savedFilters/actions/savedFilterSet';
import {
    getSortedSavedFiltersIds
} from '../../../../../../aside_panel/filterPanelBoard/components/SavedSection/hocs/selectors/getSortedSavedFiltersIds';
import {
    setSortedSavedFilterIds
} from '../../../../../../aside_panel/filterPanelBoard/components/SavedSection/hocs/effects/setSortedSavedFilterIds';
import {
    getPinnedSavedFiltersIds
} from '../../../../../../aside_panel/filterPanelBoard/components/SavedSection/hocs/selectors/getPinnedSavedFiltersIds';

export const onHide = (
    filterId: TFilterId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const filter = savedFilterSelector(getState(), filterId);
        dispatch(savedFilterActionsSet(filterId, metaSet({ isPinned: false })));
        const newFilter = { ...filter, meta: { ...filter.meta, isPinned: false }};
        dispatch(patchFilter(filterId, newFilter)).then(() => {
            dispatch(savedFilterSet(filterId, newFilter));
            const state = getState();
            const filterIds = [...getSortedSavedFiltersIds(state, MY_WORK_FILTER_BOARD_ID).filter(id => id !== filterId)];
            const pinnedFilterIds = getPinnedSavedFiltersIds(state, MY_WORK_FILTER_BOARD_ID);
            let index = 0;
            for (let i = pinnedFilterIds.length - 1; i >= 0; i--) {
                if (filterIds.includes(pinnedFilterIds[i])) {
                    index = filterIds.indexOf(pinnedFilterIds[i]) + 1;
                    break;
                }
            }
            filterIds.splice(index, 0, filterId);
            dispatch(setSortedSavedFilterIds(MY_WORK_FILTER_BOARD_ID, filterIds));
        });
    }
    return action;
}
